import {cdmMw} from '../api';

export const reasonCodeResource = {
    api: cdmMw,
    url: '/api/options-trades/reason-codes',
    useCache: true,
    parseResponse: ({data}) => data.map((data) => ({label: data, value: data})),
    defaultValue: []
};
